
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/enrich",
      function () {
        return require("private-next-pages/docs/enrich/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/enrich"])
      });
    }
  